export default "__VITE_ASSET__DPPzayRU__"